/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPanel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 19v2H5v-2zm12 0v2h-2v-2zM3 19v2H1v-2zm20 0v2h-2v-2zm-12 0v2H9v-2zm4 0v2h-2v-2zM3 15v2H1v-2zm20 0v2h-2v-2zm-4-8v10H5V7zm-2 2H7v6h10zM3 11v2H1v-2zm20 0v2h-2v-2zM3 7v2H1V7zm20 0v2h-2V7zM3 3v2H1V3zm4 0v2H5V3zm12 0v2h-2V3zm4 0v2h-2V3zM11 3v2H9V3zm4 0v2h-2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPanel as Panel };
